import { Typography, Box } from "@mui/material";
export function Glossary(props) {
  const { panel: __panel__ } = props;
  return (
    <Box className="pk__page">
      <Box className="pk__block">
        <Box className="pk__info">
          <Typography variant="caption" color="secondary.dark">
            Last updated July, 22 2026
          </Typography>
        </Box>
        <Typography
          variant="h4"
          color="#606060"
          paddingTop={5}
          paddingBottom={2}
        >
          <strong>Uniform Definitions</strong>
        </Typography>
        <Box className="pk__body">
          <Box className="stub stub--title">
            <span className="token header">1.</span>
            <div>
              <span className="token header">“Access Plan”</span>means the plan
              that governs pricing, access levels as to specific Games and Game
              Content, the specifics of a Participant’s role in connection with
              the Polycaik Platform, and other elements of a Participant’s use
              of the Polycaik Platform, as further defined in the Platform
              Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">2.</span>
            <div>
              <span className="token header">“Audio Recording”</span>
              means sound recorded in or performed via any media (now known or
              later discovered), including sound effects, voices, music, beats,
              white noise, and other stimuli to the auditory centers of the
              brain.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">3.</span>
            <div>
              <span className="token header">“AUP”</span>means the acceptable
              use policy for the Polycaik Platform, as specified in the Platform
              Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">4.</span>
            <div>
              <span className="token header">“Confidential Information”</span>
              means any non-public information disclosed by one party to
              another, whether orally or in writing, that is designated as
              confidential or that reasonably should be understood to be
              confidential given the nature of the information and the
              circumstances of disclosure. The term “Confidential Information”
              includes non-public business strategies and non-public
              technologies. The term “Confidential Information” means any
              Content before its public disclosure.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">5.</span>
            <div>
              <span className="token header">“Content Library”</span>means the
              centralized library for Games and Game Content.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">6.</span>
            <div>
              <span className="token header">“Contributor”</span>means a person
              or entity that submits Game Content to the Polycaik Platform.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">7.</span>
            <div>
              <span className="token header">“Contributor Payout”</span>means
              the amount Polycaik owes Contributor from revenue generated from
              Contributor Game Content sales after deducting the Revenue Share
              and any applicable taxes or permitted deductions.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">8.</span>
            <div>
              <span className="token header">
                “Copyleft Open Source Software”
              </span>
              means software subject to a license that requires, as a condition
              of use, modification, or distribution of such software, that such
              software or other software combined or distributed with such
              software be: (i) disclosed or distributed in source code form;
              (ii) licensed for the purpose of making derivative works; or (iii)
              redistributable at no charge. The term “Copyleft Open Source
              Software” includes software subject to the GPL or MPL.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">9.</span>
            <div>
              <span className="token header">“Beta Agreement”</span>is the
              agreement between Polycaik and the Beta Participants.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">10.</span>
            <div>
              <span className="token header">“Beta Participant”</span>is a
              person who has been approved in accordance with the onboarding
              process to test and pilot the Polycaik Platform under the Beta
              Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">11.</span>
            <div>
              <span className="token header">“Developer”</span>
              means the author of a Game offered via the Polycaik Platform.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">12.</span>
            <div>
              <span className="token header">“Developer Payout”</span>
              means the amount Polycaik owes Developer from revenue generated
              from Developer Games, including premium Games after deducting the
              Revenue Share and any applicable taxes or permitted deductions.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">13.</span>
            <div>
              <span className="token header">“Documentation”</span>means, to the
              extent made available by Polycaik: (i) user manuals and training
              materials for the Polycaik Platform; and (ii) guidance concerning
              the use of the Polycaik Platform.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">14.</span>
            <div>
              <span className="token header">“Effective Date” </span>
              is the date on which Participant agrees to the Polycaik Platform
              Agreement and, as applicable, the Game Development Agreement, and
              the Gamer Agreement. If Participant is a Beta Participant, the
              “Effective Date” is the date on which Beta Participant agrees to
              the Beta Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">15.</span>
            <div>
              <span className="token header">“Fees”</span>
              means the amount Participant owe Polycaik for use of its services.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">16.</span>
            <div>
              <span className="token header">“Game” </span>means an interactive
              experience designed to entertain, challenge, or engage players
              through a structured set of rules and objectives.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">17.</span>
            <div>
              <span className="token header">“Game Content”</span>
              means content designed for use in a Game. The term “Game Content”
              includes: (i) Narrative; (ii) Graphics; (iii) Video Recordings;
              (iv) Audio Recordings; and (v) characters and avatars. The term
              “Game Content” includes content (a) that is delivered via virtual
              reality, augmented reality, and other means; and (b) that is
              generated by natural persons or artificial intelligence.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">18.</span>
            <div>
              <span className="token header">“Game Development Agreement”</span>
              means the agreement between a Contributor and Developer, attached
              as{" "}
              <button
                className="link"
                onClick={() => __panel__("__developer__")}
              >
                Schedule A
              </button>{" "}
              to the Platform Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">19.</span>
            <div>
              <span className="token header">“Game Element”</span>
              means Game Content in the form of (i) separately priced individual
              components or (ii) separately priced bundled collections.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">20.</span>
            <div>
              <span className="token header">“Gamer”</span>means an individual
              playing a Game.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">21.</span>
            <div>
              <span className="token header">“Gamer Agreement”</span>means means
              the agreement between a Gamer and a Developer, attached as{" "}
              <button
                className="link"
                onClick={() => __panel__("__consumer__")}
              >
                Schedule B
              </button>{" "}
              to the Platform Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">22.</span>
            <div>
              <span className="token header">“Gamer Subscription”</span>
              means the [monthly] subscription fee paid by Gamers to play Games.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">23.</span>
            <div>
              <span className="token header">“Graphics”</span>
              means visual and aesthetic components and assets, such as
              character models, environments (including structural elements and
              props), 3D models, color palettes, textures, layouts, look and
              feel, fonts, and animations.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">24.</span>
            <div>
              <span className="token header">
                “Intellectual Property,” “IP” or “IP Rights”
              </span>
              means rights under patent law, copyright law, trademark law, data
              and database protection law, trade secret law, and law applicable
              to confidential information, and any and all similar proprietary
              rights. “Intellectual Property Rights” means those rights as they
              exist as of the Effective Date, and all such rights subsequently
              acquired during the Term.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">25.</span>
            <div>
              <span className="token header">“Narrative”</span>means the
              storyline and plot that provide context and motivation for
              characters.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">26.</span>
            <div>
              <span className="token header">“Participant”</span> means a Gamer,
              Contributor, or Developer.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">27.</span>
            <div>
              <span className="token header">“Participant Content”</span>
              means (i) Games; (ii) Game Content; and (iii) User-Generated
              Content. For the avoidance of doubt, the term “Participant
              Content” does not include Personal Information.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">28.</span>
            <div>
              <span className="token header">“Platform Agreement”</span>means
              the agreement between Polycaik and Participants entitled “Polycaik
              Platform Agreement.” The term “Platform Agreement” includes the
              Access Plan, and expressly excludes (i) the Game Development
              Agreement and (ii) the Gamer Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">29.</span>
            <div>
              <span className="token header">“Personal Information”</span>has
              the meaning set out in the Privacy Policy.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">30.</span>
            <div>
              <span className="token header">“Polycaik”</span>means Polycaik,
              LLC.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">31.</span>
            <div>
              <span className="token header">
                “Polycaik Platform” or “Platform”
              </span>
              means the infrastructure and software platform that Polycaik has
              designed to permit Participants to share Game Content, create
              Games, play Games, and engage in other Game-related activities.
              Polycaik offers its Services via the Polycaik Platform. The term
              “Polycaik Platform” includes updates and upgrades to the Polycaik
              Platform, as well as all components of the Polycaik Platform.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">32.</span>
            <div>
              <span className="token header">
                “Polycaik Platform Agreement”
              </span>
              has the same meaning as “Platform Agreement.”
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">33.</span>
            <div>
              <span className="token header">“Polycaik Store”</span>
              means the online storefront operated by Polycaik through which
              Participant may purchase Games.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">34.</span>
            <div>
              <span className="token header">“Privacy Policy”</span>
              means Polycaik’ s privacy policy, available at
              https://www.polycaik.com/privacy.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">35.</span>
            <div>
              <span className="token header">“Requirements”</span>
              means the technical, quality, and other standards set out in the
              Documentation, as well as standards set by the AUP.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">36.</span>
            <div>
              <span className="token header">“Revenue Share”</span>means the
              percentage Polycaik is entitled to retain from the gross revenue
              generated from Developer or Contributor sales.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">37.</span>
            <div>
              <span className="token header">“Services”</span>means the services
              Polycaik provides to the Participants through the Polycaik
              Platform, including: (i) organizing and making Game Content
              available; (ii) providing a development environment for Games,
              (iii) approving Games; (iv) publishing Games, (v) collecting and
              allocating revenues from Games and Game Content; (vi) providing
              identity and access management; and (vii) providing compute and
              storage resources to Contributors and Developers.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">38.</span>
            <div>
              <span className="token header">“User-Generated Content”</span>
              means contributions made by Gamers, such as custom-levels,
              avatars, mods, or skins, which can be shared and integrated into a
              Game.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token header">39.</span>
            <div>
              <span className="token header">“Video Recording”</span>means
              moving images recorded in or displayed via any media (now known or
              later discovered).
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
